import IconMute from "@/app/(site)/_components/Atoms/Icons/IconMute"
import IconPause from "@/app/(site)/_components/Atoms/Icons/IconPause"
import IconPlay from "@/app/(site)/_components/Atoms/Icons/IconPlay"
import IconUnmute from "@/app/(site)/_components/Atoms/Icons/IconUnmute"

interface VideoControlsProps {
    isPlaying: boolean
    isMuted: boolean
    hasSound: boolean
    autoplay?: boolean
    hideControls?: boolean
    onTogglePlayPause: (event: React.MouseEvent<HTMLButtonElement>) => void
    onToggleMute: (event: React.MouseEvent<HTMLButtonElement>) => void
}

export default function VideoControls({
    isPlaying,
    isMuted,
    hasSound,
    autoplay = true,
    hideControls = false,
    onTogglePlayPause,
    onToggleMute
}: VideoControlsProps) {
    if (!autoplay && hideControls) {
        return null
    }

    return (
        <div className="pointer-events-auto absolute right-16 top-16 z-20 flex items-center gap-x-6 temp-md:right-24 temp-md:top-24">
            {!hideControls && hasSound && (
                <button
                    type="button"
                    onClick={onToggleMute}
                    className="no-tap-highlight"
                    aria-label={isMuted ? "Unmute video" : "Mute video"}
                >
                    {isMuted ? (
                        <IconUnmute className="h-24 w-24" />
                    ) : (
                        <IconMute className="h-24 w-24" />
                    )}
                </button>
            )}
            <button
                type="button"
                onClick={onTogglePlayPause}
                className="no-tap-highlight"
                aria-label={isPlaying ? "Pause video" : "Play video"}
            >
                {isPlaying ? (
                    <IconPause className="h-24 w-24" />
                ) : (
                    <IconPlay className="h-24 w-24" />
                )}
            </button>
        </div>
    )
}
